import { useQuery } from "@tanstack/react-query";

import { getVerificationEditingRequests, getVerificationEditingRequestsAdmin } from "services";

import { getEnvironment } from "utils";

import { GET_VERIFICATION_EDITING_REQUESTS } from "consts";

import { GetVerificationEditingRequestsResponse } from "models";

type QueryFnParams = {
  farmId: string;
  isAdmin?: boolean;
};

const env = getEnvironment();

export const useGetVerificationEditingRequests = ({ farmId, isAdmin = env.admin }: QueryFnParams) =>
  useQuery<GetVerificationEditingRequestsResponse>({
    queryKey: [GET_VERIFICATION_EDITING_REQUESTS, farmId, isAdmin],
    queryFn: async () => (isAdmin ? getVerificationEditingRequestsAdmin({ farmId }) : getVerificationEditingRequests({ farmId })),
    enabled: !!farmId,
    staleTime: 1000 * 60 * 5,
  });
